
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/physicians/[...slug]",
      function () {
        return require("private-next-pages/physicians/[...slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/physicians/[...slug]"])
      });
    }
  